// Отключает автозапуск Prism: подсветку вызывает codeBlocks() на каждой странице,
// включая переходы через PJAX. Импортируется до prismjs — порядок импортов важен.

window.Prism = window.Prism || {};
window.Prism.manual = true;
